export default () => {
  const filterPaymentDataByPaymentName = (payments, searchPaymentName) => {
    if (payments.length <= 0 || !searchPaymentName) {
      return [];
    }

    return payments.filter(
      (payment) =>
        payment.code.toLowerCase() === searchPaymentName.toLowerCase()
    );
  };

  const filterPaymentsByFiat = (activeFiat, payments) => {
    return payments.filter((payment) =>
      payment.supported_fiat.includes(activeFiat.toUpperCase())
    );
  };

  const filterPaymentProvider = (payments, paymentName) => {
    const findMatchingPaymentProviderByName = filterPaymentDataByPaymentName(
      payments,
      paymentName
    );

    return findMatchingPaymentProviderByName[0];
  };

  const filterPaymentsByCoins = (activeCoin, payments) => {
    return payments.filter((payment) =>
      payment.supported_coin.includes(activeCoin.toUpperCase())
    );
  };

  const filterPaymentsByFiatAndCoin = (activeFiat, activeCoin, payments) => {
    return filterPaymentsByFiat(activeFiat, payments).filter((payment) =>
      payment.supported_coin.includes(activeCoin.toUpperCase())
    );
  };

  /**
   * Pulls all current selected payment's and
   * Active Fiat's transactional limits.
   *
   * @param activeFiat {Object}
   * @param activePayment {Object}
   * @param payments {Array of Objects}
   * @returns {Object} {min, max}
   * ie. applepaygiv : {min: 69, max: 6969}
   */

  const filterPaymentLimit = (activeFiat, activePayment, payments) => {
    if (!activeFiat || !activePayment || !payments) {
      return;
    }
    const activePaymentData = filterPaymentsByFiat(activeFiat, payments).find(
      (payment) => payment.code.toLowerCase() === activePayment?.toLowerCase()
    );

    if (!activePaymentData || activePaymentData.length <= 0) {
      return;
    }

    const limitsByFiat = activePaymentData.transaction_limits.find(
      (fiat) => fiat.fiat_code.toLowerCase() === activeFiat?.toLowerCase()
    );

    if (!limitsByFiat || limitsByFiat.length <= 0) {
      return;
    }

    return limitsByFiat;
  };

  return {
    filterPaymentsByFiatAndCoin,
    filterPaymentDataByPaymentName,
    filterPaymentLimit,
    filterPaymentProvider,
  };
};
